import React from "react";
import PropTypes from "prop-types";
import CardItem from "../CardItem";
import CardSettings from "components/CardSettings";
import styles from "./CardSettingsItem.module.css";

export function CardSettingsItem({
  cardInfo,
  isDefault,
  isPrimary,
  onTogglePrimary,
  onSetDefault,
  onEdit,
  onDelete,
}) {
  return (
    <div className={styles.container}>
      <div className={styles.cardRow}>
        <CardItem
          cardInfo={cardInfo}
          isSelected={isDefault}
          onSelect={onSetDefault}
        />
        <div className={styles.settings}>
          <CardSettings
            isDefault={isDefault}
            isPrimary={isPrimary}
            onDelete={onDelete}
            onTogglePrimary={onTogglePrimary}
            onEdit={onEdit}
            onSetDefault={onSetDefault}
          />
        </div>
      </div>
    </div>
  );
}

CardSettingsItem.propTypes = {
  cardInfo: PropTypes.shape({
    lastFour: PropTypes.string.isRequired,
    nickName: PropTypes.string.isRequired,
    expireMonth: PropTypes.string.isRequired,
    expireYear: PropTypes.string.isRequired,
    zipCode: PropTypes.string,
  }),
  isDefault: PropTypes.bool,
  isPrimary: PropTypes.bool,
  onTogglePrimary: PropTypes.func,
  onSetDefault: PropTypes.func,
  onEdit: PropTypes.func,
  onDelete: PropTypes.func,
};

export default CardSettingsItem;
